<div class="item">

  <a
    [target]="openInNewPage ? '_blank' : undefined"
    [routerLink]="['/file-case', data.id]"
  >
    <div
      class="item-link"
      coreTooltip="Sayfaya Git"
      (click)="openInNewPage ?  openInNewTab(data.id) : closeDialog()"
      role="button"
      tabindex="-1"
    >
      D
    </div>
  </a>
  <div *ngIf="data.fileNo"><b>{{ data.fileNo }}</b></div>

  <div *ngIf="data.patientFullName">{{ data.patientFullName }}</div>

  <div *ngIf="data.idNumber" coreTooltip="T.C. Kimlik No">{{ data.idNumber }}</div>

  <div *ngIf="data.phones?.length">
    <span *ngFor="let phone of data.phones; let isLast = last">
      {{ phone }}<span *ngIf="!isLast">, </span>
    </span>
  </div>
  <div class="pin" *ngIf="!pinned">
    <p-button icon="pi pi-star" coreTooltip="Favorilere Ekle" [text]="true" size="small" (onClick)="pinItem()"></p-button>
  </div>

  <div class="pinned" *ngIf="pinned">
    <p-button icon="pi pi-star-fill" coreTooltip="Favorilerden Kaldır" [text]="true" size="small" (onClick)="unpinItem()"></p-button>
  </div>

</div>